import Brand from "../../../shared/components/Brand";
import { Link } from "react-router-dom";
import SignInForm from "../components/SignInForm";

export default function SignIn() {
  return (
    <div className="flex min-h-[calc(100svh-4rem)] w-full max-w-sm flex-col items-center justify-center px-2 py-4 sm:min-h-0 sm:max-w-xs sm:px-6 sm:py-0">
      <div className="flex items-center">
        <Brand size="xl" />
      </div>
      <SignInForm />
      <div className="flex items-center">
        <p className="pb-4 text-center text-sm text-label-dark sm:pb-10">
          Don’t have an account?{" "}
          <Link to="/sign-up" className="text-gray-200 underline">
            Sign up here
          </Link>
        </p>
      </div>
    </div>
  );
}
